export class MenuSezioneDeliverect {
    menuSezioneId?: number;
    deliverectId?: string;

    constructor() {
        this.deliverectId = "";
    }

    static fromJson(json: any) {
        let result = new MenuSezioneDeliverect();
        result.menuSezioneId = json.menuSezioneId;
        result.deliverectId = json.deliverectId;
        return result;
    }
}